import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import user_register from "./user_register.vue";

window.G_HEADER = createApp({
    name : "G_HEADER",
    id : "G_HEADER",
    components : {
        user_register : user_register,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);

G_HEADER.mount('#user_register');